import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { MawopService } from 'app/modules/equipment-registration/services/mawop.service';
import { Mawop, MawopCalculator, MawopCalculatorItem } from 'app/modules/equipment-registration/model/mawop.model';
import { MawopCalculatorFormModalComponent } from '../mawop-calculator-form-modal/mawop-calculator-form-modal.component';
import { module } from "app/modules/equipment-registration/equipment-registration.module";

@Component({
    selector: 'app-mawop-calculator-modal',
    templateUrl: './mawop-calculator-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./mawop-calculator-modal.component.scss']
})
export class MawopCalculatorModalComponent {
    searchForm: UntypedFormGroup;
    dt: any
    startingIndex: number = 0
    isLoading: boolean = false
    isIntermediateExist: boolean = false

    constructor(
        public dialogRef: MatDialogRef<FormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Mawop,
        private service: MawopService,
        private dialog: MatDialog,
    ) { }

    ngOnInit() {
        this.setDataTable();
        this.setPage({ offset: 0 });
    }

    ngAfterViewInit() {
    }

    setPage(pageInfo) {
        this.service
            .getMawopCalculator(this.data.id)
            .subscribe((pagedData) => {
                this.dt.page.totalPages = pagedData.data.mawopCalculator.length;
                this.dt.page.totalRecords = pagedData.data.mawopCalculator.length;
                this.dt.rows = pagedData.data.mawopCalculator;

                this.isIntermediateExist = this.dt.rows.some(row => row.casing === 'Intermediate')
            });
    }

    setDataTable() {
        this.dt = {
            page: {
                totalRecords: 0,
                totalPages: 0,
                offset: 0,
            },
            rows: [],
        };
    }

    form(action: 'create' | 'update', row: MawopCalculatorItem | null = null) {
        const data: MawopCalculator = {
            mawopId: this.data.id,
            mawopCalculator: [row]
        }
        const dialogRef = this.dialog.open(MawopCalculatorFormModalComponent, {
            data: {
                data,
                action
            },
            width: '100%',
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.isUpdate) {
                this.setPage({ offset: 0 });
            }
        });
    }
}
